module.exports = flarum.core.compat['components/LinkButton'];